import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Export all invoice-related components
export { default as EnhancedBikeInvoice } from './Invoice/invoice';
export { default as InvoiceForm } from './Invoice/InvoiceForm';
export { default as InvoiceList } from './Invoice/InvoiceList';
export { default as PrintInvoiceTemplate } from './Invoice/PrintInvoiceTemplate';